import { useEffect, useState } from 'react';
const getInitialState = (query, defaultState) => {
  if (defaultState !== undefined) {
    return defaultState;
  }
  return window.matchMedia(query).matches;
};
const useMedia = (query, defaultState) => {
  const [state, setState] = useState(getInitialState(query, defaultState));
  useEffect(() => {
    let mounted = true;
    const mql = window.matchMedia(query);
    const onChange = () => {
      if (!mounted) {
        return;
      }
      setState(!!mql.matches);
    };
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
    } else {
      // to handle Safari < 14: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList#browser_compatibility
      mql.addListener(onChange);
    }
    setState(mql.matches);
    return () => {
      mounted = false;
      if (mql.removeEventListener) {
        mql.removeEventListener('change', onChange);
      } else {
        mql.removeListener(onChange);
      }
    };
  }, [query]);
  return state;
};
export default useMedia;